import React from "react";
import Overview from "./Overview";
import Add from "./Add";
import Edit from "./Edit";

import { PositionProvider } from "../../../context/PositionContext";

export const DataCompany = () => {
  return (
    
      <PositionProvider>
        <Overview />
      </PositionProvider>
    
  );
};

export const AddDataCompany = () => {
  return (
    
      
        <Add />
      
    
  );
};

export const EditDataCompany = () => {
  return (
    
      
        <Edit />
      
    
  );
};
